// extracted by mini-css-extract-plugin
export default {"connectionSettingsForm":"c056736cea3e","configurationFooter":"e3368735d6e6","generateKey":"f52126453931"};